import React from 'react';
import Button from 'emerald-ui/lib/Button';

const Credits = () => {
  function handleClick() {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }

  return (
    <div className="credits">
      <h1>Development direction: Jorge Sanes</h1>
      <h1>Development: Jhonatan Salcedo</h1>
      <h1>Design: Melissa Porras</h1>
      <Button onClick={handleClick}>Reload</Button>
    </div>
  );
};

export default Credits;
